export default "<app-full-layout></app-full-layout>"